import { FETCH_DISCOUNT_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
  selectList: [],
};

const discountListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DISCOUNT_LIST:
      return { list: action.payload, others: action.others };
    default:
      return state;
  }
};

export default discountListReducer;
